/* istanbul ignore file */
import React, { useCallback } from 'react';
import { filterNotHiddenItem, getTernaryValue } from 'common/utilities/utils';
import {
  menuNavigation,
  setFirstCategoryActive,
  changeMenulistOrder,
} from '../NutritionAllergenUtilities/NutritionAllergenUtils';
import { Link, scroller } from 'react-scroll';

const NutritionAllergenMenuLink = ({
  isMobile,
  menu,
  categories,
  setActiveMenuSelection,
  history,
  hasSubcategory,
  handleSetActive,
  getMenusSubcategory,
  onItemClick,
}) => {
  const setFirstCategoryActiveMemoized = useCallback(
    (event, index, name, url, filterNotHiddenItem, categories, scroller, setActiveMenuSelection, history) => {
      setFirstCategoryActive(
        event,
        index,
        name,
        url,
        filterNotHiddenItem,
        categories,
        scroller,
        setActiveMenuSelection,
        history,
      );
    },
    [],
  );

  const updatedMenuData = menu?.length && changeMenulistOrder(menu);
  const filteredItems = updatedMenuData?.length && filterNotHiddenItem(updatedMenuData);

  const onClickHandler = (event, name, url, index) => {
    if (isMobile) {
      menuNavigation(categories, url, history, index);
    } else {
      setFirstCategoryActiveMemoized(
        event,
        index,
        name?.trim(),
        url,
        filterNotHiddenItem,
        categories,
        scroller,
        setActiveMenuSelection,
        history,
      );
    }
  };

  return (
    <ul className={isMobile ? 'mob-outer-ul' : 'outer-ul'}>
      {filteredItems?.length &&
        filteredItems.map(({ id, isHidden, url, name, dname, categories: categoryData }, index) => {
          return (
            !isHidden && (
              <li key={id} id={`category-name-${id}`}>
                <Link
                  data-testid='category-click-test'
                  to={name.trim()}
                  onClick={event => onClickHandler(event, name, url, index)}
                  spy={true}
                  offset={-130}
                  smooth={true}
                  isDynamic={true}
                  duration={1500}
                  delay={100}
                  activeClass={getTernaryValue(isMobile, 'active', null)}
                  className={!isMobile && `${hasSubcategory(categoryData) ? 'caret' : ''}`}
                  onSetActive={() => document.querySelector('li > a.active')?.scrollIntoView({ block: 'nearest' })}
                >
                  {dname[0].value}
                </Link>
                {!isMobile && getMenusSubcategory(categoryData || [], handleSetActive, onItemClick)}
              </li>
            )
          );
        })}
    </ul>
  );
};

export default React.memo(NutritionAllergenMenuLink);
